import { Box, Typography } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import TkButton from "../../components/atoms/TkButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { fakeTableList, monthMappings, schema, stepperData } from "./parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  httpAPI_BUS008,
  httpAPI_STA015,
  httpAPI_STA016,
  httpAPI_STA024,
  httpAPI_STA028,
} from "./api/request";
import dayjs from "dayjs";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkTable from "../../components/atoms/TkTable";
import {
  IAPI_BUS008_Request,
  IAPI_STA015_Request,
  IAPI_STA024_Response,
  IAPI_STA028_Response,
} from "../../type/apiType";
import "./_style.scss";
import { CheckedList } from "../../type/apiType/IAPI_FAC008";
import { IBusinessContextData } from "../../type/contextType/businessContextType";
import _ from "lodash";
import { FacilityNameList } from "../../type/apiType/IAPI_STA016";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { CorpTypeList2, TransferReason } from "../../assets/data/Constants";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { IJob_01Props } from "../../type/contextType/businessContext/IJob_01";
import { IJob_15Props } from "../../type/contextType/businessContext/IJob_15";
import { IJob_23Props } from "../../type/contextType/businessContext/IJob_23";

/**
 * SCRC060108 加入登録手続き
 * @return SCRC060108 加入登録手続き
 */
const SCRC060108 = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [openData, setOpenData] = useState<any>(false);
  const userType = state?.authInfo?.userType;
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const isUserTypeDaiKoSya =
    userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const contractorNo = isUserTypeKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const businessType = businessState.common?.businessType;
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const jobTypeList = [
    {
      businessType: "JOB-01",
      jobTypeName: "job_01",
    },
    {
      businessType: "JOB-15",
      jobTypeName: "job_15",
    },
    {
      businessType: "JOB-23",
      jobTypeName: "job_23",
    },
  ];
  const jobTypeName = jobTypeList.find(
    (item) => item.businessType === businessType
  )?.jobTypeName as keyof typeof businessState;
  const job_xx: IJob_01Props & IJob_15Props & IJob_23Props =
    businessState[jobTypeName];
  const applyId = location.state?.applyId ?? job_xx?.applyId;
  const [notBeMonth, setNotBeMonth] = useState<any>({});
  const [year, setYear] = useState(2023);
  const [showTable, setShowTable] = useState<boolean>(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [resAPISTA028, setResAPISTA028] = useState<IAPI_STA028_Response>({});
  const [resAPISTA024, setResAPISTA024] = useState<IAPI_STA024_Response>({});
  const [source, setSource] = useState<FacilityNameList[]>();
  const [checkedMasPastFlg, setCheckedMasPastFlg] = useState<
    string | undefined
  >("");
  const [selectedMasQuitReason, setSelectedMasQuitReason] = useState<
    string | undefined
  >("");
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);
  const [disabled, setDisabled] = useState(false);
  const tableRef = useRef<{ getAllValue: () => any }>();
  const [openSave, setOpenSave] = useState(false);
  const [nowTransferCd, setNowTransferCd] = useState("");
  const [indexBtn, setIndexBtn] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const reqDataRef = useRef<any>();

  const judgeJoinDate = (date?: string): boolean => {
    return dayjs(date).format("MM-DD") === "04-01";
  };

  const judgeCancelDate = (date?: string): boolean => {
    return dayjs(date).format("MM-DD") === "03-31";
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期表示
  const handleInit = async () => {
    let resArr = stateFakeTableList.current;

    // 契約者（法人）名
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isUserTypeKiko;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;

    // 引継ぎコード
    let transferCd = resArr.find((item) => item.keyword === "transferCd")!;
    transferCd.getTransferCode = handleReading;

    // (2)持回情報.戻るボタンフラグがtrueの場合
    if (location.state?.backButtonFlag) {
      for (let i in job_xx?.registrationProcedureInfo) {
        let targetObj = resArr.find((item) => item.keyword === i)!;

        targetObj &&
          (targetObj.setDefaultValue =
            job_xx?.registrationProcedureInfo[
              i as keyof (typeof job_xx)["registrationProcedureInfo"]
            ]);
      }
      setNowTransferCd(job_xx?.registrationProcedureInfo?.transferCd ?? "");
      // 施設名
      let facilityNameList = resArr.find(
        (item) => item.keyword === "facilityNameList"
      )!;

      if (businessType === "JOB-01" || businessType === "JOB-15") {
        // ・持回情報.業務タイプ＝JOB-01またはJOB-15の場合、入出力項目.施設名の初期設定に持回情報.施設番号の施設を設定する
        facilityNameList.disabled = true;

        const sourceItem = {
          facilityName: job_xx?.registrationProcedureInfo?.facilityName,
          facilityNo: job_xx?.registrationProcedureInfo?.facilityNo,
        };
        setSource([sourceItem]);
        facilityNameList.selectPropsList = [
          {
            label: `${sourceItem.facilityNo}:${sourceItem.facilityName}`,
            value: sourceItem.facilityNo,
          },
        ];
        facilityNameList.setDefaultValue = sourceItem.facilityNo;
      } else {
        const _source =
          job_xx?.registrationProcedureInfo?.facilityNameList || [];
        setSource(_source);
        facilityNameList.selectPropsList =
          _source?.map?.((item: any) => ({
            label: `${item.facilityNo}:${item.facilityName}`,
            value: item.facilityNo,
          })) || [];
        facilityNameList.setDefaultValue =
          job_xx?.registrationProcedureInfo?.facilityNo;
      }

      // 加入年月日
      let joinDate = resArr.find((item) => item.keyword === "joinDate")!;
      if (businessType === "JOB-01") {
        joinDate.disabled = true;

        if (
          businessState?.job_01?.registrationProcedureInfo
            ?.pastContractCancelDate
        ) {
          // 1.持回情報.解除年月日が設定されている場合、持回情報.加入年月日を設定し非活性にする。
          joinDate.setDefaultValue =
            businessState.job_01?.registrationProcedureInfo?.joinDate;
        } else {
          // 2.上記以外の場合、持回情報.契約希望日を設定し非活性にする。
          joinDate.setDefaultValue = businessState.job_01?.desiredContractDate;
        }
      } else if (businessType === "JOB-15") {
        joinDate.disabled = true;
        if (
          businessState?.job_15?.registrationProcedureInfo
            ?.pastContractCancelDate ||
          businessState.job_15?.pastContractCancelDate ||
          businessState.job_15?.registrationProcedureInfo
            ?.rearrangementJoinFlg === "1"
        ) {
          // 1.持回情報.解除年月日が設定されている場合、持回情報.加入年月日を設定し非活性にする。
          joinDate.setDefaultValue =
            businessState?.job_15?.registrationProcedureInfo?.joinDate;
        } else {
          // 2.上記以外の場合、持回情報.新設・申出日を設定し、非活性にする。
          joinDate.setDefaultValue = businessState?.job_15?.foundDate;
        }
      } else {
        if (
          businessType === "JOB-23" &&
          (job_xx?.registrationProcedureInfo?.transferReason ===
            TransferReason["継続異動減"] ||
            job_xx?.registrationProcedureInfo?.continuousJoinFlg === "1")
        ) {
          joinDate.disabled = true;
        }
        joinDate.setDefaultValue = job_xx?.registrationProcedureInfo?.joinDate;
      }

      // 被共済職員でなくなった理由
      let masQuitReason = resArr.find(
        (item) => item.keyword === "masQuitReason"
      )!;

      // 被共済職員でなくなった年月日
      let masQuitDate = resArr.find((item) => item.keyword === "masQuitDate")!;

      //被共済職員であったことの有無
      let masPastFlg = resArr.find((item) => item.keyword === "masPastFlg")!;
      if (job_xx?.registrationProcedureInfo?.masPastFlg === "0") {
        // 無の場合
        masPastFlg.setDefaultValue = "0";
        masQuitReason.disabled = true;
        masQuitDate.disabled = true;
      } else {
        masPastFlg.setDefaultValue = "1";
      }

      // 被共済職員でなくなった理由
      masQuitReason.onGetValue = handleChangeMasQuitReason;

      // ①（持回情報.業務タイプ＝JOB-01かつ持回情報.契約希望日の年月が4/1）または、
      // 	（持回情報.業務タイプ＝JOB-15かつ持回情報.新設・申出年月日の年月が4/1）の場合
      // ②当該職員情報を「引継ぎコード」を使った加入、または「配置換え」で取得した職員（配置換加入フラグ="1"）
      const showStatusTableConditions =
        (businessType === "JOB-01" &&
          judgeJoinDate(businessState.job_01?.desiredContractDate)) ||
        (businessType === "JOB-15" &&
          (judgeCancelDate(
            businessState.job_15?.registrationProcedureInfo
              ?.pastContractCancelDate
          ) ||
            judgeJoinDate(businessState.job_15?.foundDate)));
      const showStatusTableConditions2 =
        job_xx?.registrationProcedureInfo?.emploeeStatusDisplayFlg === "1" ||
        job_xx?.registrationProcedureInfo?.rearrangementJoinFlg === "1" ||
        !!job_xx?.registrationProcedureInfo?.transferCd;
      if (showStatusTableConditions && showStatusTableConditions2) {
        setShowTable(true);
        setYear(job_xx?.registrationProcedureInfo?.year!);

        let naranaiTuski: any = {};
        Object.keys(monthMappings).forEach((key) => {
          let targetObj = (job_xx.registrationProcedureInfo as any)[key];
          targetObj && (naranaiTuski[key] = targetObj);
        });
        setNotBeMonth(naranaiTuski);
      }
      setCheckedMasPastFlg(job_xx?.registrationProcedureInfo?.masPastFlg);
      setSelectedMasQuitReason(
        job_xx?.registrationProcedureInfo?.masQuitReason
      );

      if (
        (job_xx?.registrationProcedureInfo?.transferCd &&
          job_xx?.registrationProcedureInfo?.bContractNo &&
          job_xx?.registrationProcedureInfo?.bContractName &&
          job_xx?.registrationProcedureInfo?.bStaffNo) ||
        job_xx?.registrationProcedureInfo?.transferReason ===
          TransferReason["継続異動減"] ||
        job_xx?.registrationProcedureInfo?.continuousJoinFlg === "1"
      ) {
        resArr.find((item) => item.keyword === "masPastFlg")!.disabled = true;
        resArr.find((item) => item.keyword === "masQuitReason")!.disabled =
          true;
        resArr.find((item) => item.keyword === "masQuitDate")!.disabled = true;
        resArr.find((item) => item.keyword === "bContractNo")!.disabled = true;
        resArr.find((item) => item.keyword === "bContractName")!.disabled =
          true;
        resArr.find((item) => item.keyword === "bStaffNo")!.disabled = true;
      }

      setStatecorpInfoList([...resArr]);
      setState({
        ...state,
        errorMsgId: "",
      });
    } else if (job_xx?.staffNo) {
      //(1)持回情報.職員番号が設定されている場合
      // b.加入登録手続き修正参照APIを呼び出す
      try {
        const res = await httpAPI_STA024({
          contractorNo,
          staffNo: job_xx?.staffNo,
          applyId,
          businessType,
        });

        // 初期表示
        if (res.resultCd === "I0000") {
          setResAPISTA024(res);
          setNowTransferCd(res.transferCd ?? "");
          for (let i in res) {
            let targetObj = resArr.find((item) => item.keyword === i)!;

            targetObj &&
              (targetObj.setDefaultValue = res[i as keyof typeof res]);
          }

          // 施設名
          let facilityNameList = resArr.find(
            (item) => item.keyword === "facilityNameList"
          )!;

          if (businessType === "JOB-01" || businessType === "JOB-15") {
            // ・持回情報.業務タイプ＝JOB-1またはJOB-15の場合、入出力項目.施設名の初期設定に持回情報.施設番号の施設を設定する
            facilityNameList.disabled = true;

            const sourceItem = {
              facilityName: job_xx?.facilityName,
              facilityNo: job_xx?.facilityNo,
            };
            setSource([sourceItem]);
            facilityNameList.selectPropsList = [
              {
                label: `${sourceItem.facilityNo}:${sourceItem.facilityName}`,
                value: sourceItem.facilityNo,
              },
            ];
            facilityNameList.setDefaultValue = sourceItem.facilityNo;
          } else {
            const _source = [...(res.facilityNameList ?? [])];
            setSource(_source);
            facilityNameList.selectPropsList =
              _source?.map?.((item: any) => ({
                label: `${item.facilityNo}:${item.facilityName}`,
                value: item.facilityNo,
              })) || [];
            facilityNameList.setDefaultValue = location?.state?.facilityNo;
          }

          // 加入年月日
          let joinDate = resArr.find((item) => item.keyword === "joinDate")!;
          if (businessType === "JOB-01") {
            joinDate.disabled = true;
            if (res?.pastContractCancelDate) {
              //1.持回情報.解除年月日が設定されている場合、1.(3).加入年月日を設定し非活性にする。
              joinDate.setDefaultValue = res?.joinDate;
            } else {
              // 2.上記以外の場合、持回情報.契約希望日を設定し非活性にする。
              joinDate.setDefaultValue =
                businessState?.job_01?.desiredContractDate;
            }
          } else if (businessType === "JOB-15") {
            joinDate.disabled = true;
            if (
              !!res.pastContractCancelDate ||
              !!job_xx.pastContractCancelDate ||
              res.rearrangementJoinFlg === "1"
            ) {
              // 1.持回情報.解除年月日が設定されている場合、1.(3).加入年月日を設定し非活性にする。
              joinDate.setDefaultValue = res?.joinDate;
            } else {
              // 2.上記以外の場合、持回情報.新設・申出日を設定し、非活性にする。
              joinDate.setDefaultValue = businessState?.job_15?.foundDate;
            }
          } else {
            if (businessType === "JOB-23" && res?.continuousJoinFlg === "1") {
              joinDate.disabled = true;
            }
            joinDate.setDefaultValue = res?.joinDate;
          }

          // 被共済職員でなくなった理由
          let masQuitReason = resArr.find(
            (item) => item.keyword === "masQuitReason"
          )!;

          // 被共済職員でなくなった年月日
          let masQuitDate = resArr.find(
            (item) => item.keyword === "masQuitDate"
          )!;

          //被共済職員であったことの有無
          let masPastFlg = resArr.find(
            (item) => item.keyword === "masPastFlg"
          )!;
          if (res?.masPastFlg === "0") {
            // 無の場合
            masPastFlg.setDefaultValue = "0";
            masQuitReason.disabled = true;
            masQuitDate.disabled = true;
          } else {
            masPastFlg.setDefaultValue = "1";
          }
          setCheckedMasPastFlg(res?.masPastFlg);

          // 被共済職員でなくなった理由
          masQuitReason.setDefaultValue = res?.masQuitReason;
          masQuitReason.onGetValue = handleChangeMasQuitReason;
          setSelectedMasQuitReason(res?.masQuitReason);

          // ①（持回情報.業務タイプ＝JOB-01かつ持回情報.契約希望日の年月が4/1）または、
          // 	（持回情報.業務タイプ＝JOB-15かつ持回情報.新設・申出年月日の年月が4/1）の場合
          // ②1.(3).従業状況表示フラグ="1"(表示する)の場合
          const showStatusTableConditions =
            (businessType === "JOB-01" &&
              judgeJoinDate(businessState.job_01?.desiredContractDate)) ||
            (businessType === "JOB-15" &&
              (judgeCancelDate(res.pastContractCancelDate ?? res.masQuitDate) ||
                judgeJoinDate(
                  res.joinDate ?? businessState.job_15?.foundDate
                ) ||
                res.rearrangementJoinFlg === "1"));
          // 引継ぎコードが設定されて、加入日が4月1日以外の場合
          const showStatusTableConditions2 =
            res.transferCd && !judgeJoinDate(res.joinDate);
          if (
            showStatusTableConditions &&
            res.emploeeStatusDisplayFlg === "1" &&
            !showStatusTableConditions2
          ) {
            setShowTable(true);
            setYear(res.year!);

            let naranaiTuski: any = {};
            Object.keys(monthMappings).forEach((key) => {
              let targetObj = (res as any)[key];
              targetObj && (naranaiTuski[key] = targetObj);
            });
            setNotBeMonth(naranaiTuski);
          } else {
            setShowTable(false);
          }

          if (
            (res?.transferCd &&
              res?.bContractNo &&
              res?.bContractName &&
              res?.bStaffNo) ||
            res?.continuousJoinFlg === "1"
          ) {
            resArr.find((item) => item.keyword === "masPastFlg")!.disabled =
              true;
            resArr.find((item) => item.keyword === "masQuitReason")!.disabled =
              true;
            resArr.find((item) => item.keyword === "masQuitDate")!.disabled =
              true;
            resArr.find((item) => item.keyword === "bContractNo")!.disabled =
              true;
            resArr.find((item) => item.keyword === "bContractName")!.disabled =
              true;
            resArr.find((item) => item.keyword === "bStaffNo")!.disabled = true;
          }

          setStatecorpInfoList([...resArr]);

          setBusinessState({
            ...businessState,
            [jobTypeName]: {
              ...job_xx,
              tempSaveStep: res.tempSaveStep,
              registrationProcedureInfo: {
                ...job_xx?.registrationProcedureInfo,
                staffNo: res.staffNo,
              },
            } as typeof job_xx,
          });
          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          setState({
            ...state,
            errorMsgId: res?.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else if (location.state?.facilityNo ?? job_xx?.facilityNo) {
      //(2)持回情報.施設番号が設定されている場合
      // 施設名
      let facilityNameList = resArr.find(
        (item) => item.keyword === "facilityNameList"
      )!;
      // ・持回情報から画面項目を設定する。(非活性)
      facilityNameList.disabled = true;

      // 被共済職員であったことの有無
      let masPastFlg = resArr.find((item) => item.keyword === "masPastFlg")!;
      masPastFlg.setDefaultValue = "0";
      // 被共済職員でなくなった理由
      resArr.find((item) => item.keyword === "masQuitReason")!.disabled = true;
      // 被共済職員でなくなった年月日
      resArr.find((item) => item.keyword === "masQuitDate")!.disabled = true;

      const sourceItem = {
        facilityName: location.state?.facilityName ?? job_xx?.facilityName,
        facilityNo: location.state?.facilityNo ?? job_xx?.facilityNo,
      };
      setSource([sourceItem]);
      facilityNameList.selectPropsList = [
        {
          label: `${sourceItem.facilityNo}:${sourceItem.facilityName}`,
          value: sourceItem.facilityNo,
        },
      ];
      facilityNameList.setDefaultValue = sourceItem.facilityNo;

      let joinDate = resArr.find((item) => item.keyword === "joinDate")!;
      if (businessType === "JOB-01") {
        joinDate.setDefaultValue = job_xx.desiredContractDate;
        joinDate.disabled = true;
      } else if (businessType === "JOB-15") {
        if (job_xx.pastContractCancelDate) {
          joinDate.setDefaultValue = dayjs(job_xx.pastContractCancelDate).add(
            1,
            "day"
          );
        } else {
          joinDate.setDefaultValue = job_xx.foundDate;
        }
        joinDate.disabled = true;
      }
    } else {
      //(3)上記以外の場合
      // a.加入登録手続き参照APIを呼び出す（httpAPI_STA016）
      try {
        const res = await httpAPI_STA016({
          contractorNo,
          businessType,
          applyId,
        });

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });
          if (location.state?.signUpFlg || !res?.applyId) {
            let facilityNameList = resArr.find(
              (item) => item.keyword === "facilityNameList"
            )!;
            const _source = [...(res.facilityNameList ?? [])];
            setSource(_source);
            facilityNameList.selectPropsList =
              _source?.map?.((item: any) => ({
                label: `${item.facilityNo}:${item.facilityName}`,
                value: item.facilityNo,
              })) || [];
            facilityNameList.setDefaultValue = _source?.[0]?.facilityNo;

            // 被共済職員であったことの有無
            let masPastFlg = resArr.find(
              (item) => item.keyword === "masPastFlg"
            )!;
            masPastFlg.setDefaultValue = "0";
            // 被共済職員でなくなった理由
            resArr.find((item) => item.keyword === "masQuitReason")!.disabled =
              true;
            // 被共済職員でなくなった年月日
            resArr.find((item) => item.keyword === "masQuitDate")!.disabled =
              true;

            if (
              // (ⅰ)1.(3).経営者種別が「学校法人」　かつ　1.(3).契約締結日≧2015/04/01　の場合
              [
                CorpTypeList2["学校法人"],
                CorpTypeList2["学校法人（認定こども園）"],
              ].includes(res.businessOwnerClass as CorpTypeList2) &&
              new Date(res?.contractDate!) >= new Date("2015/04/01")
            ) {
              resArr.forEach((item) => (item.disabled = true));
              setDisabled(true);
              setIndexBtn(true);
              setState({
                ...state,
                errorMsgId: "TKMSG_SCR0001I",
              });
              return;
            }
            // 持回情報.新規登録フラグが"true"　または　1.(3).a.申請idが未設定の場合
          } else {
            // 1.(3).a.申請idを持回情報に設定し、加入登録手続き画面(SCR0071_1)に遷移する。
            setBusinessState({
              ...businessState,
              [jobTypeName]: {
                ...businessState[jobTypeName as keyof IBusinessContextData],
                applyId: res.applyId,
              },
            });
            navigate("/SCRC060110", {
              state: {
                deleteFlg: true,
              },
            });
          }
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  const NotBeMonthTable = () => {
    const noneCondition = Object.values(notBeMonth).every(
      (i) => i === "0" || i === "2"
    );

    // 月の配列を定義
    const monthsHeadData = [
      "無",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
      "1月",
      "2月",
      "3月",
    ];
    const headList = [
      {
        top: {
          headTitle: `${year}年度ならない月`,
        },
        bottom: monthsHeadData.map((month) => ({ headTitle: month })),
      },
      {
        top: {
          headTitle: "",
          rowSpan: 2,
        },
        headTitle: "",
      },
    ];

    const TkCheckboxList = () => {
      const months = [
        { value: "4", key: "apr" },
        { value: "5", key: "may" },
        { value: "6", key: "jun" },
        { value: "7", key: "jul" },
        { value: "8", key: "aug" },
        { value: "9", key: "sep" },
        { value: "10", key: "oct" },
        { value: "11", key: "nov" },
        { value: "12", key: "dec" },
        { value: "1", key: "jan" },
        { value: "2", key: "feb" },
        { value: "3", key: "mar" },
      ];

      return months.map((month) => ({
        align: "center" as "center",
        children: (
          <TkCheckbox
            disabled={
              notBeMonth[month.key] === "2" ||
              notBeMonth[month.key] === "3" ||
              businessState.common?.businessType === "JOB-01" ||
              job_xx?.registrationProcedureInfo?.rearrangementJoinFlg === "0" ||
              resAPISTA024.rearrangementJoinFlg === "0" ||
              !!Object.values(resAPISTA028).length
            }
            checked={
              notBeMonth[month.key] === "1" || notBeMonth[month.key] === "3"
            }
            value={month.value}
            onClick={(e: any) => {
              setNotBeMonth((prev: any) => {
                return { ...prev, [month.key]: e.target.checked ? "1" : "0" };
              });
            }}
          />
        ),
      }));
    };

    return (
      <TkTable
        headList={headList}
        bodyList={[
          [
            {
              align: "center",
              children: <TkCheckbox checked={noneCondition} disabled />,
            },

            ...TkCheckboxList(),
            {
              align: "center",
              children: (
                <TkButton onClick={handleClickChildcareLeaveCheck}>
                  育休確認
                </TkButton>
              ),
            },
          ],
        ]}
      />
    );
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let notBeMonth = resArr.find((item) => item.keyword === "notBeMonth")!;

    //従業状況欄非表示
    resArr.find((item) => item.keyword === "employmentStatus")!.showLine =
      showTable;
    notBeMonth.showLine = showTable;
    setStatecorpInfoList([...resArr]);

    notBeMonth.node = NotBeMonthTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notBeMonth, year, resAPISTA028, resAPISTA024, showTable]);

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    // 前共済契約者名
    let bContractName = resArr.find(
      (item) => item.keyword === "bContractName"
    )!;

    // 前共済契約者番号
    let bContractNo = resArr.find((item) => item.keyword === "bContractNo")!;

    // 前職員番号
    let bStaffNo = resArr.find((item) => item.keyword === "bStaffNo")!;

    if (checkedMasPastFlg === "1") {
      // 被共済職員であったことの有
      switch (selectedMasQuitReason) {
        case "1":
          //有・退職→（上記三点非表示）
          bContractName.showLine = false;
          bContractNo.showLine = false;
          bStaffNo.showLine = false;
          break;
        case "2":
          bContractName.showLine = true;
          bContractNo.showLine = true;
          bStaffNo.showLine = true;
          break;
        case "3":
          //有・解除or合算→（上記三点表示）
          bContractName.showLine = true;
          bContractNo.showLine = true;
          bStaffNo.showLine = true;
          break;
        default:
          break;
      }
    } else if (checkedMasPastFlg === "0") {
      // 被共済職員であったことの無→（上記三点非表示）
      bContractName.showLine = false;
      bContractNo.showLine = false;
      bStaffNo.showLine = false;
    } else {
      return;
    }

    setStatecorpInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedMasPastFlg, selectedMasQuitReason]);

  // 4.読み込みボタン押下時
  const handleReading = async (data: any) => {
    // 加入登録手続き引継ぎ参照API 呼び出し
    try {
      const res = await httpAPI_STA028({
        transferCd: data,
        applyId,
        facilityNo:
          job_xx?.facilityNo ?? job_xx?.registrationProcedureInfo?.facilityNo,
      });

      if (res.resultCd === "I0000") {
        setNowTransferCd(data);
        let resArr = stateFakeTableList.current;
        setResAPISTA028(res);

        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (i === "joinDate") {
            if (!(businessType === "JOB-01" || businessType === "JOB-15")) {
              targetObj.setDefaultValue = res.joinDate;
            }
            if (res.transferReason === TransferReason["継続異動減"]) {
              targetObj.disabled = true;
            }
          } else {
            targetObj &&
              (targetObj.setDefaultValue = res[i as keyof typeof res]);
          }
        }

        if (
          judgeJoinDate(res?.joinDate) &&
          res.emploeeStatusDisplayFlg === "1"
        ) {
          // 加入年月日が、4/1（年みない）場合、非活性で従業状況欄を表示する（育休ボタンは活性とする）
          setShowTable(true);
        }

        handleChangeMasPastFlg(
          res.masPastFlg,
          res.masQuitReason,
          res.masQuitDate
        );
        // 被共済職員でなくなった理由
        let masQuitReason = resArr.find(
          (item) => item.keyword === "masQuitReason"
        )!;
        masQuitReason.onGetValue = handleChangeMasQuitReason;

        // 従業状況
        const filterYear = res.year ?? job_xx?.registrationProcedureInfo?.year;
        setYear(filterYear!);
        let naranaiTuski: any = {};
        Object.keys(monthMappings).forEach((key) => {
          let targetObj = (res as any)[key];
          targetObj && (naranaiTuski[key] = targetObj);
        });

        let notBeMonth = resArr.find((item) => item.keyword === "notBeMonth")!;
        notBeMonth.showLine = true;

        resArr.find((item) => item.keyword === "masPastFlg")!.disabled = true;
        resArr.find((item) => item.keyword === "masQuitReason")!.disabled =
          true;
        resArr.find((item) => item.keyword === "masQuitDate")!.disabled = true;
        resArr.find((item) => item.keyword === "bContractNo")!.disabled = true;
        resArr.find((item) => item.keyword === "bContractName")!.disabled =
          true;
        resArr.find((item) => item.keyword === "bStaffNo")!.disabled = true;

        setCheckedMasPastFlg(res.masPastFlg);
        setSelectedMasQuitReason(res?.masQuitReason);
        setNotBeMonth(naranaiTuski);
        setStatecorpInfoList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
        setFlag(true);
      } else {
        setNowTransferCd("");
        handleChangeMasPastFlg("0", "", "");
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let masPastFlg = resArr.find((item) => item.keyword === "masPastFlg")!;
    let masQuitReason = resArr.find(
      (item) => item.keyword === "masQuitReason"
    )!;
    masPastFlg.onGetValue = handleChangeMasPastFlg;
    masQuitReason.onGetValue = handleChangeMasQuitReason;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resAPISTA028, resAPISTA024]);

  // 5.被共済職員であったことの有無 ラジオボタン 選択
  const handleChangeMasPastFlg = (
    data: any,
    resMasQuitReason?: any,
    resMasQuitDate?: any
  ) => {
    setCheckedMasPastFlg(data);
    let resArr = stateFakeTableList.current;
    // 被共済職員でなくなった理由
    let masQuitReason = resArr.find(
      (item) => item.keyword === "masQuitReason"
    )!;

    resArr.find((item) => item.keyword === "masPastFlg")!.setDefaultValue =
      data;

    // 被共済職員でなくなった年月日
    let masQuitDate = resArr.find((item) => item.keyword === "masQuitDate")!;
    let bContractNo = resArr.find((item) => item.keyword === "bContractNo")!;
    let bContractName = resArr.find(
      (item) => item.keyword === "bContractName"
    )!;
    let bStaffNo = resArr.find((item) => item.keyword === "bStaffNo")!;

    if (data === "1") {
      // 「被共済職員でなくなった理由」プルダウン、「被共済職員でなくなった年月日」入力欄を活性にする。
      masQuitReason.disabled = false;
      masQuitDate.disabled = false;
      masQuitReason.setDefaultValue =
        resAPISTA028?.masQuitReason ||
        resAPISTA024?.masQuitReason ||
        resMasQuitReason;
      masQuitDate.setDefaultValue =
        resAPISTA028?.masQuitDate ||
        resAPISTA024?.masQuitDate ||
        resMasQuitDate;
    } else if (data === "0") {
      // 「無」を選択する場合、「被共済職員でなくなった理由」プルダウン、「被共済職員でなくなった年月日」入力欄を非活性にする。
      // 「入出力項目.被共済職員でなくなった理由」をクリアする
      // 「入出力項目.被共済職員でなくなった年月日」をクリアする
      masQuitReason.setDefaultValue = "";
      masQuitReason.disabled = true;
      masQuitDate.setDefaultValue = "";
      masQuitDate.disabled = true;
      bContractNo.setDefaultValue = "";
      bContractName.setDefaultValue = "";
      bStaffNo.setDefaultValue = "";
    }
    setStatecorpInfoList([...resArr]);
  };

  // 被共済職員でなくなった理由 (選択時値の取得)
  const handleChangeMasQuitReason = (data: any) => {
    setSelectedMasQuitReason(data);
  };

  // 育休ボタン押下時
  const handleClickChildcareLeaveCheck = () => {
    const data = tableRef.current?.getAllValue();

    let saveMasPastFlg = data.masPastFlg;
    let saveQuitReason = data.masQuitReason;
    let saveQuitDate = data.masQuitDate;
    if (!+(data.masPastFlg ?? 0)) {
      saveMasPastFlg = "0";
      saveQuitReason = "";
      saveQuitDate = "";
    }
    setBusinessState({
      ...businessState,
      [jobTypeName]: {
        ...job_xx,
        registrationProcedureInfo: {
          ...job_xx?.registrationProcedureInfo,
          transferCd: data.transferCd === nowTransferCd ? nowTransferCd : "", //引継ぎコード
          facilityNo: data.facilityNameList, //施設番号
          facilityName: (source ?? []).find(
            (item) => item.facilityNo === data.facilityNameList
          )?.facilityName, //施設名称
          staffNameKana: data.staffNameKana, //法人職員氏名（ｶﾅ）
          staffNameKanji: data.staffNameKanji, //法人職員氏名（漢字）
          birthday: data.birthday, //法人職員生年月日
          sex: data.sex, //法人職員性別
          masPastFlg: saveMasPastFlg, //被共済職員であったことの有無
          masQuitReason: saveQuitReason, //被共済職員でなくなった理由
          masQuitDate: saveQuitDate, //被共済職員でなくなった年月日
          bContractName: data.bContractName, //前共済契約者名
          bContractNo: data.bContractNo, //前共済契約者番号
          bStaffNo: data.bStaffNo, //前法人職員番号
          joinDate: data.joinDate, //加入年月日
          joinCapacity: data.joinCapacity, //加入資格
          jobCd: data.jobCd, //職種番号
          salaryTableAmt: data.salaryTableAmt, //俸給表の額
          salaryAdjustmentAmt: data.salaryAdjustmentAmt, //俸給の調整額
          year, //年度
          ...notBeMonth,
          facilityNameList: source, // 施設名称リスト
          continuousJoinFlg: data.continuousJoinFlg, // 継続加入フラグ
          rearrangementJoinFlg: data.rearrangementJoinFlg, // 配置換加入フラグ
          emploeeStatusDisplayFlg:
            resAPISTA024?.emploeeStatusDisplayFlg ??
            resAPISTA028?.emploeeStatusDisplayFlg ??
            job_xx?.registrationProcedureInfo?.emploeeStatusDisplayFlg,
          pastContractCancelDate:
            resAPISTA024?.pastContractCancelDate ??
            job_xx?.registrationProcedureInfo?.pastContractCancelDate,
          transferReason:
            resAPISTA028.transferReason ??
            job_xx?.registrationProcedureInfo?.transferReason,
          bContractorNoForChildcareLeave:
            resAPISTA028.bContractNo ??
            resAPISTA024.bContractorNoForChildcareLeave,
          bStaffNoForChildcareLeave:
            resAPISTA028.bStaffNo ?? resAPISTA024.bStaffNoForChildcareLeave,
        },
      } as typeof job_xx,
    });

    navigate("/SCRC060101", {
      state: { staffNo: job_xx?.registrationProcedureInfo?.staffNo },
    });
  };

  const makeHttpObjOnSave = (obj: any): IAPI_STA015_Request => {
    let saveMasPastFlg = obj.masPastFlg;
    let saveQuitReason = obj.masQuitReason;
    let saveQuitDate = obj.masQuitDate;
    if (!+obj.masPastFlg) {
      saveMasPastFlg = "0";
      saveQuitReason = "";
      saveQuitDate = "";
    }

    return {
      contractorNo,
      applyId,
      tempSaveStep: 1,
      businessType, // 業務タイプ
      transferCd: obj.transferCd === nowTransferCd ? nowTransferCd : "", // 引継ぎコード
      facilityNo: obj.facilityNameList, //	施設番号
      staffNo: job_xx?.registrationProcedureInfo?.staffNo, // 職員番号
      staffNameKana: obj.staffNameKana, // 法人職員氏名（ｶﾅ）
      staffNameKanji: obj.staffNameKanji, // 法人職員氏名（漢字）
      birthday: obj.birthday, // 法人職員生年月日
      sex: obj.sex, // 法人職員性別
      masPastFlg: saveMasPastFlg, // 被共済職員であったことの有無
      masQuitReason: saveQuitReason, // 被共済職員でなくなった理由
      masQuitDate: saveQuitDate, // 被共済職員でなくなった年月日
      bContractName: obj.bContractName, // 前共済契約者名
      bContractNo: obj.bContractNo, // 前共済契約者番号
      bStaffNo: obj.bStaffNo, // 前職員番号
      joinDate: obj.joinDate, // 加入年月日
      joinCapacity: obj.joinCapacity, // 加入資格
      jobCd: obj.jobCd, // 職種番号
      salaryTableAmt: obj.salaryTableAmt, // 俸給表の額
      salaryAdjustmentAmt: obj.salaryAdjustmentAmt, // 俸給の調整額
      year,
      screenId: "SCRC060108", // 画面id
      checkedList,
      ...notBeMonth,
    };
  };

  const makeHttpObjOnConfirmation = (obj: any): IAPI_BUS008_Request => {
    let setStaffNo: any;
    if (job_xx?.staffNo) {
      setStaffNo = job_xx.staffNo;
    }
    if (flag) {
      setStaffNo = obj.staffNo;
    }

    return {
      contractorNo,
      facilityNo: obj.facilityNameList, // 施設番号
      staffNameKanji: obj.staffNameKanji, // 法人職員氏名（漢字）
      staffNameKana: obj.staffNameKana, // 法人職員氏名（ｶﾅ）
      birthday: obj.birthday, // 法人職員生年月日
      joinDate: obj.joinDate, // 加入年月日
      bContractorNo: obj.bContractNo, // 前共済契約者番号
      bStaffNo: obj.bStaffNo, // 前職員番号
      checkedList: checkedList,
      businessType: businessType,
      transferCd: obj.transferCd === nowTransferCd ? nowTransferCd : "", // 引継ぎコード
      aStaffNo: setStaffNo, // 異動後法人職員番号
    };
  };

  const onCheckAndSubmit = async (
    data: any,
    index: number = 0,
    check80: boolean = true
  ) => {
    reqDataRef.current = data;
    // 業務チェック
    const age = dayjs(data.joinDate).diff(dayjs(data.birthday), "year");
    if (data.salaryTableAmt <= 73999) {
      // 入出力項目.俸給表の額 ≦ 73,999円
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0012E",
      });
      return;
      // 年齢（入出力項目.生年月日）が14歳以下の場合
    } else if (age < 15) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0013E",
      });
      return;
      // 年齢（入出力項目.生年月日）が80歳以上の場合
    } else if (age >= 80 && check80 && index !== 0) {
      setState({
        ...state,
        errorMsgId: "",
      });
      setOpenData(data);
      return;
    } else if (data.joinDate <= data.masQuitDate) {
      // 「加入年月日」が「被共済職員でなくなった年月日」より以前の日付の場合。
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0123E",
      });
      return;
    }

    if (index === 0) {
      try {
        // 加入登録手続き更新API 呼び出し
        const res = await httpAPI_STA015({
          ...makeHttpObjOnSave(data),
        });
        setCheckedList(res.checkedList || []);

        if (res.resultCd === "I0000") {
          setCheckedList([]);
          setBusinessState({
            ...businessState,
            [jobTypeName]: {
              ...job_xx,
              tempSaveStep: 1,
              applyId: res.applyId,
              registrationProcedureInfo: {
                ...job_xx?.registrationProcedureInfo,
                staffNo: res.staffNo,
              },
            },
          });
          setState({
            ...state,
            errorMsgId: "",
          });
          setOpenSave(true);
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          setOpenData(undefined);
          setOpenSave(false);
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      //業務チェック
      const today = new Date();
      const nextYearDate = new Date(
        today.setFullYear(today.getFullYear() + 1)
      ).setHours(0, 0, 0, 0);
      const joinDate = new Date(data.joinDate).setHours(0, 0, 0, 0);
      if (joinDate >= nextYearDate) {
        //入出力項目.加入年月日 ≧ システム日付 + 1年
        setOpenWarning(true);
        return;
      } else {
        handleConsistencyCheckApi();
      }
    }
  };

  //加入登録時の整合性チェックAPI 呼び出し
  const handleConsistencyCheckApi = async () => {
    try {
      const res = await httpAPI_BUS008({
        ...makeHttpObjOnConfirmation(reqDataRef.current),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        if (jobTypeName) {
          let saveMasPastFlg = reqDataRef.current.masPastFlg;
          let saveQuitReason = reqDataRef.current.masQuitReason;
          let saveQuitDate = reqDataRef.current.masQuitDate;
          if (!+reqDataRef.current.masPastFlg) {
            saveMasPastFlg = "0";
            saveQuitReason = "";
            saveQuitDate = "";
          }
          setBusinessState({
            ...businessState,
            [jobTypeName]: {
              ...job_xx,
              registrationProcedureInfo: {
                ...job_xx?.registrationProcedureInfo,
                transferCd:
                  reqDataRef.current.transferCd === nowTransferCd
                    ? nowTransferCd
                    : "", //引継ぎコード
                facilityNo: reqDataRef.current.facilityNameList, //施設番号
                facilityName: (source || []).find(
                  (item: any) =>
                    item.facilityNo === reqDataRef.current.facilityNameList
                )?.facilityName, //施設名称
                staffNameKana: reqDataRef.current.staffNameKana, //法人職員氏名（ｶﾅ）
                staffNameKanji: reqDataRef.current.staffNameKanji, //法人職員氏名（漢字）
                birthday: reqDataRef.current.birthday, //法人職員生年月日
                sex: reqDataRef.current.sex, //法人職員性別
                masPastFlg: saveMasPastFlg, //被共済職員であったことの有無
                masQuitReason: saveQuitReason, //被共済職員でなくなった理由
                masQuitDate: saveQuitDate, //被共済職員でなくなった年月日
                bContractName: reqDataRef.current.bContractName, //前共済契約者名
                bContractNo: reqDataRef.current.bContractNo, //前共済契約者番号
                bStaffNo: reqDataRef.current.bStaffNo, //前法人職員番号
                joinDate: reqDataRef.current.joinDate, //加入年月日
                joinCapacity: reqDataRef.current.joinCapacity, //加入資格
                jobCd: reqDataRef.current.jobCd, //職種番号
                salaryTableAmt: reqDataRef.current.salaryTableAmt, //俸給表の額
                salaryAdjustmentAmt: reqDataRef.current.salaryAdjustmentAmt, //俸給の調整額
                year: showTable ? year : (null as any), //年度
                ...(showTable ? notBeMonth : {}), // ならない月
                facilityNameList: source, // 施設名称リスト
                continuousJoinFlg:
                  resAPISTA024?.continuousJoinFlg ??
                  job_xx?.registrationProcedureInfo?.continuousJoinFlg, // 継続加入フラグ
                rearrangementJoinFlg:
                  resAPISTA024?.rearrangementJoinFlg ??
                  job_xx?.registrationProcedureInfo?.rearrangementJoinFlg, // 配置換加入フラグ
                emploeeStatusDisplayFlg:
                  resAPISTA024?.emploeeStatusDisplayFlg ??
                  resAPISTA028?.emploeeStatusDisplayFlg ??
                  job_xx?.registrationProcedureInfo?.emploeeStatusDisplayFlg,
                pastContractCancelDate:
                  resAPISTA024?.pastContractCancelDate ??
                  job_xx?.registrationProcedureInfo?.pastContractCancelDate,
                transferReason:
                  resAPISTA028.transferReason ??
                  job_xx?.registrationProcedureInfo?.transferReason, // 異動理由
              },
            },
          });
        }

        navigate("/SCRC060009");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpenData(undefined);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 現在の職員一覧 ボタン 押下
  const handleClickStaffList = () => {
    const data = tableRef.current?.getAllValue();
    // 次の画面で使う項目を「持回情報」に設定
    if (jobTypeName) {
      let saveMasPastFlg = data.masPastFlg;
      let saveQuitReason = data.masQuitReason;
      let saveQuitDate = data.masQuitDate;
      if (!+data.masPastFlg) {
        saveMasPastFlg = "0";
        saveQuitReason = "";
        saveQuitDate = "";
      }
      setBusinessState({
        ...businessState,
        [jobTypeName]: {
          ...businessState[jobTypeName as keyof IBusinessContextData],
          registrationProcedureInfo: {
            ...job_xx?.registrationProcedureInfo,
            transferCd: data.transferCd === nowTransferCd ? nowTransferCd : "", //引継ぎコード
            facilityNo: data.facilityNameList, //施設番号
            facilityName: (source || []).find(
              (item: any) => item.facilityNo === data.facilityNameList
            )?.facilityName, //施設名称
            staffNameKana: data.staffNameKana, //法人職員氏名（ｶﾅ）
            staffNameKanji: data.staffNameKanji, //法人職員氏名（漢字）
            birthday: data.birthday, //法人職員生年月日
            sex: data.sex, //法人職員性別
            masPastFlg: saveMasPastFlg, //被共済職員であったことの有無
            masQuitReason: saveQuitReason, //被共済職員でなくなった理由
            masQuitDate: saveQuitDate, //被共済職員でなくなった年月日
            bContractName: data.bContractName, //前共済契約者名
            bContractNo: data.bContractNo, //前共済契約者番号
            bStaffNo: data.bStaffNo, //前法人職員番号
            joinDate: data.joinDate, //加入年月日
            joinCapacity: data.joinCapacity, //加入資格
            jobCd: data.jobCd, //職種番号
            salaryTableAmt: data.salaryTableAmt, //俸給表の額
            salaryAdjustmentAmt: data.salaryAdjustmentAmt, //俸給の調整額
            year, //年度
            ...notBeMonth,
            facilityNameList: source, // 施設名称リスト
            continuousJoinFlg: data.continuousJoinFlg, // 継続加入フラグ
            rearrangementJoinFlg: data.rearrangementJoinFlg, // 配置換加入フラグ
            pastContractCancelDate: data.pastContractCancelDate,
          },
        },
      });
    }
    // 職員の登録内容の確認画面（SCR0079_3）に遷移する。
    navigate("/SCRC060033");
  };

  //ワーニングモーダルのOK押下
  const handleOpenSubmitModal = () => {
    setOpenWarning(false);
    handleConsistencyCheckApi();
  };

  return (
    <Box className="SCRC060108" data-testid="SCRC060108PageForTest">
      <TkStepper
        steps={stepperData}
        activeStep={0}
        savaStep={job_xx?.tempSaveStep}
      />

      <Box className="infoManualAndBtn">
        <Box className="infoManual">
          <Typography>
            加入する施設、職員情報を入力して、「入力内容確認」ボタンを押してください。
          </Typography>
          <Typography>
            複数人加入する場合は、次の画面で続けて入力ボタンを押してください。
          </Typography>
          <Typography>
            なお、
            <span className="redText">合算制度を利用して加入される場合</span>
            は、前共済契約者で発行された
            <span className="redText">引継ぎコードを入力</span>
            することで、これまでの勤務期間（被共済職員期間）と次の勤務先での
            <span className="redText">勤務期間（被共済職員期間）を通算</span>
            することができます。
          </Typography>
        </Box>
        {businessType === "JOB-23" && !isUserTypeDaiKoSya && (
          <TkButton onClick={handleClickStaffList} disabled={indexBtn}>
            現在の職員一覧
          </TkButton>
        )}
      </Box>
      <Box className="joinAndRegisterProcedures">
        <TkFakeTable
          ref={tableRef}
          list={statecorpInfoList}
          ruleSchema={schema}
          showButton={true}
          onCheckAndSubmit={onCheckAndSubmit}
          submitButtonGroup={[
            {
              submitButtonText: "一時保存",
              submitButtonDisabled: disabled,
            },
            {
              submitButtonText: "入力内容確認",
              submitButtonDisabled: disabled,
            },
          ]}
        />
      </Box>

      <TkMessageDialog
        open={openSave}
        onOky={() => setOpenSave(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        cancelText=""
        okText="はい"
      />
      <TkMessageDialog
        open={!!openData}
        onOky={() => onCheckAndSubmit(openData, 1, false)}
        onCancel={() => setOpenData(undefined)}
        title="入力内容確認"
        contextText="入力された「生年月日」の場合、登録職員が８０歳以上になります、生年月日の入力に誤りがないか確認してください"
        cancelText="いいえ"
        okText="はい"
      />
      <TkMessageDialog
        open={openWarning}
        onOky={handleOpenSubmitModal}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0027W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRC060108;
